import axios from "axios";

const instance = axios.create({
  // baseURL: "http://127.0.0.1:8000/api/admin/",
  // baseURL: "https://ridey-backend.developnetwork.net/api/admin/",
  baseURL: "https://backend.rideyapp.com/api/admin/",

  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log(JSON.parse(localStorage.getItem("admin_user")))

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_user");

      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default instance;
